export default {
    organisationBaseData: 'Daten',
    organisationUsers: 'Nutzer',
    organisationCategories: 'Kategorien',
    organisationAssociationSettings: 'Verbandseinstellungen',
    organisationTransferAgreement: 'Weitergabevertrag',
    organisationEducationalConcept: 'Bildungskonzept',
    organisationActivities: 'Historie',
}
